export default __webpack_public_path__ + "static/media/unionpay.60cd0218.png";